import { useState } from 'react';
import { useAuth } from '../../contexts/authContext';
function readLens(key) {
    try {
        return sessionStorage.getItem(key) === 'team' ? 'team' : 'my';
    } catch  {
        return 'my'; // storage blocked (private mode, policy): default lens
    }
}
function writeLens(key, value) {
    try {
        sessionStorage.setItem(key, value);
    } catch  {
    // storage blocked: the lens still changes for this mount
    }
}
/**
 * Growth Home "My work / Team work" lens, remembered per tab (GRW-22: the
 * sessionStorage access is guarded, AUDIT P3; a throwing storage means 'my').
 */ export function useGrowthHomeLens() {
    const { user } = useAuth();
    const key = `growth-home-lens:${user?.tenant_id}:${user?.id}`;
    const [lens, setLens] = useState(()=>readLens(key));
    const select = (value)=>{
        writeLens(key, value);
        setLens(value);
    };
    return [
        lens,
        select
    ];
}
